import { sign } from './utils';
class Registry {
    store = new Map();
    get(Model, props) {
        const key = sign(props);
        const store = this.store.get(Model) || {};
        return store[key] || null;
    }
    set(Model, props, instance) {
        const key = sign(props);
        const store = Object.assign(this.store.get(Model) || {}, {
            [key]: instance
        });
        this.store.set(Model, store);
    }
}
export const registry = new Registry();
